import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './myPortfolioCapsulesPreview.png';

export const myPortfolioCapsulesDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Portfolio Capsules widget allows you to sort and display
                symbols in your portfolio for a particular topic. Click on the
                settings icon to configure the topic and the number of capsules
                to display.
            </div>
        </>
    ),
    previews: [
        {
            title: 'Portfolio Capsules',
            src: preview,
            altText: 'my-portfolio-capsules-preview',
        },
    ],
};
